export function getStylePropertyValueFromDOM(property) {
    return getComputedStyle(document.documentElement).getPropertyValue(property);
}

export function setStyles(element,
    newStyle,
    initialStyle = { top: 'auto', bottom: 'auto', left: 'auto' }) {
    const style = { ...initialStyle, ...newStyle };

    Object.keys(style).forEach(prop => {
        const value = style[prop];
        const strValue = typeof value === 'number' ? `${ Math.floor(value) }px` : value;
        element.style.setProperty(prop, strValue);
    });
}